// Build information, automatically generated by `ng-info`
const build = {
    version: "0.1.2",
    timestamp: "Wed May 06 2026 13:13:38 GMT+0330 (Iran Standard Time)",
    message: null,
    git: {
        user: "reyrey998",
        branch: "reyhaneh_ssoInsooo",
        hash: "d78009",
        fullHash: "d78009f473c15770e199f0ae4d72e75eb05051e8"
    }
};

export default build;